const L10N: {[key: string]: {[key: string]: string}} = {
  "ko": {
    "btnReset": "초기화",
    "btnClose": "닫기"
  },
  "en": {
    "btnReset": "Reload",
    "btnClose": "Close"
  }
};

export default L10N;